export default {
  key: 'Bb',
  suffix: 'maj13',
  positions: [{
    frets: 'x11233',
    fingers: '011234',
    barres: 1,
    capo: true
  }, {
    frets: '655565',
    fingers: '211131',
    barres: 5,
    capo: true
  }, {
    frets: '667786',
    fingers: '112341',
    barres: 6,
    capo: true
  }, {
    frets: 'xdccaa',
    fingers: '042311',
    barres: 10,
    capo: true
  }]
};